import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=6161358b&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6161358b')) {
      api.createRecord('6161358b', component.options)
    } else {
      api.reload('6161358b', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=6161358b&", function () {
      api.rerender('6161358b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25526uOI11vNK/JS/childrenage.vue"
export default component.exports